module.exports = __webpack_public_path__ + "static/media/villa-azul-3.b7713906.webp";